import { render, staticRenderFns } from "./kpi-expander.component.vue?vue&type=template&id=5dcc3150&scoped=true"
import script from "./kpi-expander.component.vue?vue&type=script&lang=ts"
export * from "./kpi-expander.component.vue?vue&type=script&lang=ts"
import style0 from "./kpi-expander.component.vue?vue&type=style&index=0&id=5dcc3150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcc3150",
  null
  
)

export default component.exports